import { Component } from '@angular/core';

@Component({
  selector: 'shared-big-page-loader',
  templateUrl: './big-page-loader.component.html',
  styleUrls: ['./big-page-loader.component.scss'],
})
export class BigPageLoaderComponent {
}
